// extracted by mini-css-extract-plugin
export default {"container":"paymentFailure_container__wqwtp","failureCard":"paymentFailure_failureCard__bIRRE","icon":"paymentFailure_icon__R2+PP","retryButton":"paymentFailure_retryButton__T-8eh"};